import { render } from "./SalaryInformationDetail.vue?vue&type=template&id=96688c7e"
import script from "./SalaryInformationDetail.vue?vue&type=script&lang=js"
export * from "./SalaryInformationDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\ekk-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__